import React from "react";

export const Gitlab = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <path d="m503.5 204.6-.7-1.8L433.1 21c-1.4-3.5-3.9-6.6-7.2-8.6-2.4-1.6-5.1-2.5-8-2.8-2.9-.3-5.7.1-8.4 1.1s-5.1 2.6-7.1 4.8c-1.9 2.1-3.3 4.6-4.1 7.4l-47 144H160.8l-47.1-144c-.8-2.8-2.2-5.3-4.1-7.4-2-2.1-4.4-3.8-7.1-4.8-2.6-1-5.5-1.4-8.4-1.1-2.8.3-5.6 1.2-8 2.8-3.3 2-5.8 5.1-7.2 8.6L9.3 202.8l-.8 1.8c-10 26.2-11.2 55-3.5 82 7.8 26.9 24.1 50.7 46.5 67.6l.2.2.6.4 106 79.5 52.6 39.7 32 24.2c3.7 1.9 8.3 4.3 13 4.3 4.7 0 9.3-2.4 13-4.3l32-24.2 52.6-39.7 106.7-79.9.3-.3c22.4-16.9 38.7-40.6 45.6-67.5 8.6-27 7.4-55.8-2.6-82z" />
  </svg>
);
